// @ts-nocheck
import { name2num, num2name, } from "../../../../inside/payment/PaymentCurrency";
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../../runtime/json/scalar";
import { WireType, } from "../../../../../runtime/wire/index";
import { default as serialize, } from "../../../../../runtime/wire/serialize";
import { encodeBinary as encodeBinary_1, decodeBinary as decodeBinary_1, } from "../../../../google/protobuf/StringValue";
import { tsValueToWireValueFns, unpackFns, } from "../../../../../runtime/wire/scalar";
import { encodeBinary as encodeBinary_2, decodeBinary as decodeBinary_2, } from "../../../../google/protobuf/BoolValue";
import { default as Long, } from "../../../../../runtime/Long";
import { default as deserialize, } from "../../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        like: undefined,
        authorityConfigIds: [],
        calculateDaily: undefined,
        currency: "UNSET",
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.like !== undefined)
        result.like = value.like;
    result.authorityConfigIds = value.authorityConfigIds.map(value => tsValueToJsonValueFns.int64(value));
    if (value.calculateDaily !== undefined)
        result.calculateDaily = value.calculateDaily;
    if (value.currency !== undefined)
        result.currency = tsValueToJsonValueFns.enum(value.currency);
    return result;
}
export function decodeJson(value) {
    var _a, _b;
    const result = getDefaultValue();
    if (value.like !== undefined)
        result.like = value.like;
    result.authorityConfigIds = (_b = (_a = value.authorityConfigIds) === null || _a === void 0 ? void 0 : _a.map((value) => jsonValueToTsValueFns.int64(value))) !== null && _b !== void 0 ? _b : [];
    if (value.calculateDaily !== undefined)
        result.calculateDaily = value.calculateDaily;
    if (value.currency !== undefined)
        result.currency = jsonValueToTsValueFns.enum(value.currency);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.like !== undefined) {
        const tsValue = value.like;
        result.push([1, ((tsValue) => ({ type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }))({ value: tsValue })]);
    }
    for (const tsValue of value.authorityConfigIds) {
        result.push([2, tsValueToWireValueFns.int64(tsValue)]);
    }
    if (value.calculateDaily !== undefined) {
        const tsValue = value.calculateDaily;
        result.push([3, ((tsValue) => ({ type: WireType.LengthDelimited, value: encodeBinary_2(tsValue) }))({ value: tsValue })]);
    }
    if (value.currency !== undefined) {
        const tsValue = value.currency;
        result.push([4, { type: WireType.Varint, value: new Long(name2num[tsValue]) }]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    var _a, _b;
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = (_a = (wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined)) === null || _a === void 0 ? void 0 : _a.value;
        if (value === undefined)
            break field;
        result.like = value;
    }
    collection: {
        const wireValues = wireMessage.filter(([fieldNumber]) => fieldNumber === 2).map(([, wireValue]) => wireValue);
        const value = Array.from(unpackFns.int64(wireValues));
        if (!value.length)
            break collection;
        result.authorityConfigIds = value;
    }
    field: {
        const wireValue = wireFields.get(3);
        if (wireValue === undefined)
            break field;
        const value = (_b = (wireValue.type === WireType.LengthDelimited ? decodeBinary_2(wireValue.value) : undefined)) === null || _b === void 0 ? void 0 : _b.value;
        if (value === undefined)
            break field;
        result.calculateDaily = value;
    }
    field: {
        const wireValue = wireFields.get(4);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.Varint ? num2name[wireValue.value[0]] : undefined;
        if (value === undefined)
            break field;
        result.currency = value;
    }
    return result;
}
